import {DateTime} from 'luxon';

import styles from './DateBox.module.scss'

export default ({ datetime }) => {
  const luxon = DateTime.fromISO(`${datetime.localDate}T${datetime.localTime}`);

  return (
    <div className={styles.datetime}>
      <div className={styles.box}>
        <div className={styles.month}>{luxon.monthShort} {luxon.year}</div>
        <div className={styles.date}>{luxon.day}</div>
        <div className={styles.day}>{luxon.weekdayShort}</div>
      </div>
      <div className={styles.time}>{luxon.toLocaleString(DateTime.TIME_SIMPLE)}</div>
      <div className={styles.timezone}>{datetime.timeZoneName}</div>
    </div>
  )
}
